import styled from 'styled-components';

export const LinkList = styled.li`
  strong {
    margin-bottom: 1rem;
    display: block;
    line-height: 1;
  }

  &[dir='ltr'] {
    strong {
      font-family: 'DINBold';
    }
  }

  &[dir='rtl'] {
    strong {
      font-family: GESSTwoDWTCMedium, sans-serif;
    }
  }
`;
